import * as R from 'ramda';
import isActiveCategory from './isActiveCategory';
import isActiveMedication from './isActiveMedication';
import { PATIENT_STATUS } from './patientStatus.constants';

const endTherapeuticCategory = R.curry(
    ({ therapeuticCategoryOptOutDate, therapeuticCategoryOptOutReason }, category) => {
        return R.evolve(
            {
                status: R.mergeLeft({
                    end: therapeuticCategoryOptOutDate,
                    endReason: therapeuticCategoryOptOutReason,
                    optIn: false,
                }),
            },
            category
        );
    }
);

const endMedication = R.curry(({ medicationEndDate, medicationEndReason }, medication) =>
    R.evolve(
        {
            status: R.mergeLeft({ end: medicationEndDate, endReason: medicationEndReason }),
        },
        medication
    )
);

function dischargePatient(
    {
        therapeuticCategoryOptOutDate,
        therapeuticCategoryOptOutReason,
        medicationEndDate,
        medicationEndReason,
        patientStatus,
        deceasedDate,
    },
    data
) {
    const config = {
        therapeuticCategoryOptOutDate,
        therapeuticCategoryOptOutReason,
        medicationEndDate,
        medicationEndReason,
    };

    const updatedData = R.evolve(
        {
            therapeuticCategory: R.map(R.when(isActiveCategory, endTherapeuticCategory(config))),
            medications: R.map(R.when(isActiveMedication, endMedication(config))),
        },
        data
    );

    if (!patientStatus) {
        return updatedData;
    }

    return {
        ...updatedData,
        status: patientStatus,
        deceasedDate: patientStatus?.ValueName === PATIENT_STATUS.DECEASED ? deceasedDate || null : null,
    };
}

export default dischargePatient;
